<div class="modal-header">
    <h4 class="modal-title">Registro de Actualización de Stock</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    </button>
</div>
<div class="modal-body">
    <form [formGroup]="form">
        <div class="row">
            <div class="mb-3 col-sm-6">
                <label for="fecha">Fecha</label>
                <input type="text" class="form-control" id="fecha" formControlName="fecha">
            </div>

            <div class="mb-3 col-sm-6">
                <label for="tipo_actualizacion">Tipo de actualización</label>
                <input type="text" class="form-control" id="tipo_actualizacion" formControlName="tipo_actualizacion">
            </div>

            <div class="mb-3 col-12">
                <label for="detalle">Detalle</label>
                <textarea class="form-control" id="detalle" rows="3" formControlName="detalle"></textarea>
            </div>

            <div class="col-12">
                <kuv-table [useFilter]="false" [usePagination]="false" [columns]="columnas" [actions]="[]" [useSort]="false" [useIndex]="false" [isRounded]="true" [items]="element.linea_actualizaciones"></kuv-table>
            </div>

        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss('Cancel click')">Cancelar</button>
</div>